'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
                                                                                                                                                                                                                                                                   * Generic address entry field used for adding a new address
                                                                                                                                                                                                                                                                   * Wrap all the address entry fields in a <div class="row"/> when using the grid
                                                                                                                                                                                                                                                                   * - Address fields are generic because they vary based on the user's locale
                                                                                                                                                                                                                                                                   * - Shows a state list dropdown if it exists
                                                                                                                                                                                                                                                                   * - Validates the postcode (zipcode) and shows the error message (vx_form-control-message)
                                                                                                                                                                                                                                                                   * - If it's a US address, show the state and zipcode on the same line
                                                                                                                                                                                                                                                                   */

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _aphrodite = require('aphrodite');

var _reactTextInput = require('react-text-input');

var _reactTextInput2 = _interopRequireDefault(_reactTextInput);

var _propValidators = require('prop-validators');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var STYLES = _aphrodite.StyleSheet.create({
	dropdown: {
		padding: 0,
		textIndent: 10,
		boxSizing: 'content-box',
		WebkitAppearance: 'none',
		MozAppearance: 'none',
		appearance: 'none',
		'@-moz-document url-prefix()': {
			textIndent: 2.5
		}
	},

	errorMessage: {
		WebkitTransition: 'all 0.25s ease-in-out',
		MozTransition: 'all 0.25s ease-in-out',
		msTransition: 'all 0.25s ease-in-out',
		OTransition: 'all 0.25s ease-in-out',
		transition: 'all 0.25s ease-in-out'
	}
});

/**
 * State dropdown list
 */
var StateList = _react2.default.createClass({
	displayName: 'StateList',

	propTypes: {
		id: _react.PropTypes.string.isRequired,
		country: _react.PropTypes.string.isRequired,
		fieldName: _react.PropTypes.string.isRequired,
		label: _react.PropTypes.string.isRequired,
		stateList: _propValidators.stateListPropType,
		required: _react.PropTypes.bool,
		value: _react.PropTypes.string, // default value
		errorMessage: _react.PropTypes.string,
		handleChangeField: _react.PropTypes.func.isRequired,
		handleFocus: _react.PropTypes.func,
		handleBlur: _react.PropTypes.func
	},

	getInitialState: function getInitialState() {
		return {
			value: this.props.value || ''
		};
	},
	handleChangeOption: function handleChangeOption(event) {
		var value = event.target.value;
		this.setState({ value: value });
		this.props.handleChangeField(this.props.fieldName, value);
	},
	render: function render() {
		var _props = this.props;
		var id = _props.id;
		var fieldName = _props.fieldName;
		var required = _props.required;
		var label = _props.label;
		var _props$stateList = _props.stateList;
		var stateList = _props$stateList === undefined ? [] : _props$stateList;


		return _react2.default.createElement(
			'div',
			{ className: (0, _classnames2.default)('vx_form-group', {
					'col-sm-12': this.props.country !== 'US',
					'col-sm-8': this.props.country === 'US',
					'vx_has-error': this.props.errorMessage
				}), style: { paddingTop: 0, margin: '10px 0 0', position: 'relative' } },
			_react2.default.createElement(
				'select',
				{ name: fieldName, id: id,
					className: 'form-control vx_form-control ' + (0, _aphrodite.css)(STYLES.dropdown),
					required: required,
					value: this.state.value,
					onChange: this.handleChangeOption,
					style: STYLES.dropdown },
				_react2.default.createElement(
					'option',
					{ value: '', disabled: true },
					label
				),
				stateList.map(function (_ref) {
					var code = _ref.$id;
					var value = _ref.$elt;
					return _react2.default.createElement(
						'option',
						{ key: code, value: code },
						value
					);
				})
			),
			_react2.default.createElement('span', { className: 'vx_selectIcon_error' }),
			_react2.default.createElement('label', { htmlFor: fieldName, className: 'icon icon-arrow-down-small', style: {
					position: 'absolute', right: 10, top: '50%', cursor: 'default', pointerEvents: 'none'
				} })
		);
	}
});

/**
 * A generic address entry field that handles different fields specified by griffin
 * Values will be stored in component state
 */
var AddressEntryField = _react2.default.createClass({
	displayName: 'AddressEntryField',

	propTypes: {
		id: _react.PropTypes.string.isRequired,
		country: _react.PropTypes.string.isRequired,
		fieldName: _react.PropTypes.string.isRequired,
		required: _react.PropTypes.bool,
		maxLength: _react.PropTypes.number,
		validationPattern: _react.PropTypes.string,
		labels: _react.PropTypes.object.isRequired, // addressEntryFormat.strings
		value: _react.PropTypes.string, // default value
		errorMessage: _react.PropTypes.string,
		handleChangeField: _react.PropTypes.func.isRequired,
		handleFocus: _react.PropTypes.func,
		handleBlur: _react.PropTypes.func,
		handlePostcodeHasError: _react.PropTypes.func.isRequired
	},

	getDefaultProps: function getDefaultProps() {
		return {
			handleFocus: function handleFocus() {},
			handleBlur: function handleBlur() {}
		};
	},
	getInitialState: function getInitialState() {
		return {
			value: '',
			zipErrorMessage: ''
		};
	},
	handleFocus: function handleFocus(value) {
		this.props.handleFocus(value);
	},


	/**
  * Validate postcode onBlur
  * - set the state with the error message from the labels object
  * - call parent's handlePostcodeHasError to disable submission of the form
  */
	handleBlur: function handleBlur(value) {
		var shouldValidatePostcode = this.props.fieldName === 'postcode' && this.state.value;

		// if the postcode is invalid based on the validationPattern,
		// set zipErrorMessage = labels.validationError that we get from Griffin
		if (shouldValidatePostcode && !new RegExp('^' + this.props.validationPattern + '$').test(this.state.value)) {
			this.setState({ zipErrorMessage: this.props.labels.validationError });
			this.props.handlePostcodeHasError(true);
		} else {
			this.setState({ zipErrorMessage: '' });
			this.props.handlePostcodeHasError(false);
		}

		this.props.handleBlur(value);
	},


	/**
  * Handle changing the input value
  * - call parent's handleChangeField to store the address value
  * - set the state so the component also keeps track of this value
  * @param {String} value - the input value
  */
	handleChangeField: function handleChangeField(value) {
		this.props.handleChangeField(this.props.fieldName, value);
		this.setState({ value: value });
		return value;
	},
	render: function render() {
		var _props2 = this.props;
		var id = _props2.id;
		var country = _props2.country;
		var fieldName = _props2.fieldName;
		var required = _props2.required;
		var maxLength = _props2.maxLength;
		var validationPattern = _props2.validationPattern;
		var labels = _props2.labels;
		var errorMessage = _props2.errorMessage;
		var handleChangeField = _props2.handleChangeField;
		var optionalLabel = labels.optionalLabel;
		var stateList = labels.stateList;

		optionalLabel = required ? '' : ' ' + (optionalLabel || '');
		var label = '' + labels[fieldName + 'Label'] + optionalLabel;
		var attributes = {
			required: required,
			maxlength: maxLength,
			pattern: validationPattern
		};

		// if there is a stateList, let's render a <StateList/> dropdown
		if (this.props.fieldName === 'state' && stateList && stateList.length) {
			return _react2.default.createElement(StateList, _extends({
				id: id,
				country: country,
				fieldName: fieldName,
				label: label,
				value: this.props.value
			}, attributes, {
				stateList: stateList,
				errorMessage: errorMessage,
				handleChangeField: handleChangeField }));
		}

		var zipErrorMessage = this.state.zipErrorMessage;

		var errorMessageClassNames = (0, _classnames2.default)((0, _aphrodite.css)(STYLES.errorMessage), {
			'vx_form-control-message': errorMessage || zipErrorMessage
		});
		var errorStyles = {
			height: 0,
			padding: 0
		};
		if (errorMessage || zipErrorMessage) {
			errorStyles = { height: '100%' };
		}

		return _react2.default.createElement(
			'div',
			{ className: (0, _classnames2.default)({
					'col-sm-12': this.props.country !== 'US' || fieldName !== 'postcode',
					'col-sm-4': this.props.country === 'US' && fieldName === 'postcode',
					'vx_has-error-with-message': errorMessage || zipErrorMessage
				}), style: { margin: '10px 0 0' } },
			_react2.default.createElement(_reactTextInput2.default, _extends({
				id: id,
				name: '' + fieldName,
				className: 'vx_form-control vx_form-control_complex',
				label: label,
				value: this.props.value
			}, attributes, {
				handleFocus: this.handleFocus,
				handleBlur: this.handleBlur,
				handleChange: this.handleChangeField })),
			_react2.default.createElement(
				'div',
				{ className: errorMessageClassNames, style: errorStyles },
				errorMessage || zipErrorMessage
			)
		);
	}
});

exports.default = AddressEntryField;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /workspace/donate-gro-release/~/react-address-entry-field/dist/index.js
// module id = 360
// module chunks = 6